export const bmFiscalYearValidation = (dateString) => {
    // let fiscalStartYear = Number(import.meta.env.VITE_REACT_BM_FISCAL_START_YEAR);
    // let fiscalEndYear = Number(import.meta.env.VITE_REACT_BM_FISCAL_END_YEAR)
    const fiscalStartYear = Number((new Date()).getFullYear()) - 5;
    const fiscalEndYear = Number((new Date()).getFullYear()) + 5;
    return Number(dateString.split('-')[0]) >= fiscalStartYear && Number(dateString.split('-')[0]) <= fiscalEndYear
}